import React from "react";
import Menu from "../Menu";
import CommonSendComponent from "../../components/CommonSendComponent";
import { getSendConfig } from "../../Configs/SendConfigs";

const SendAudio = () => {
  const config = getSendConfig('audio');

  return (
    <>
      <Menu />
      <CommonSendComponent config={config} />
    </>
  );
};

export default SendAudio;
